import { defineMessages } from 'react-intl'

const scope = `procurify.components.BudgetCategoryBudgetSettingsModal`

export default defineMessages({
  budgetSettingsModalTitle: {
    id: `${scope}.budgetSettingsModalTitle`,
    defaultMessage: 'Budget Settings',
  },
  successNotificationTitle: {
    id: `${scope}.successNotificationTitle`,
    defaultMessage: 'Success',
  },
  errorNotificationTitle: {
    id: `${scope}.errorNotificationTitle`,
    defaultMessage: 'Error',
  },
  budgetOverageHeader: {
    id: `${scope}.budgetOverageHeader`,
    defaultMessage: 'Budget Overage',
  },
  budgetOverageCheckboxLabel: {
    id: `${scope}.budgetOverageToggleLabel`,
    defaultMessage: 'Budget Overage Checkbox',
  },
  budgetOverageCheckboxTitle: {
    id: `${scope}.budgetOverageCheckboxTitle`,
    defaultMessage: 'budget-overage-checkbox',
  },
  budgetOverageDescriptionText: {
    id: `${scope}.budgetOverageDescriptionText`,
    defaultMessage:
      'Allow spend to be approved even when the budget is exceeded.',
  },
  budgetOverageEnabledNotificationText: {
    id: `${scope}.budgetOverageEnabledNotificationText`,
    defaultMessage: 'Budget Overage has been enabled.',
  },
  budgetOverageDisabledNotificationText: {
    id: `${scope}.budgetOverageDisabledNotificationText`,
    defaultMessage: 'Budget Overage has been disabled.',
  },
  budgetOverageToggleErrorText: {
    id: `${scope}.budgetOverageToggleErrorText`,
    defaultMessage:
      'There was a problem updating the Budget Overage setting, please try again later.',
  },
  budgetSettingsSaveButtonText: {
    id: `${scope}.budgetSettingsSaveButtonText`,
    defaultMessage: 'Save Settings',
  },
  budgetSettingsCancelButtonText: {
    id: `${scope}.budgetSettingsCancelButtonText`,
    defaultMessage: 'Cancel',
  },
})
